import { useState } from "react";
import { CURRENCY_CONFIG } from "../utils/currency";

interface CurrencyPickerProps {
  currencies: string[];
  selectedCurrency: string;
  onCurrencyChange: (currency: string) => void;
  textColor?: string;
}

export default function CurrencyPicker({
  currencies,
  selectedCurrency,
  onCurrencyChange,
  textColor = "#374151",
}: CurrencyPickerProps) {
  const [isOpen, setIsOpen] = useState(false);

  if (currencies.length <= 1) return null;

  const currentConfig = CURRENCY_CONFIG[selectedCurrency] ?? {
    flag: "",
    label: selectedCurrency.toUpperCase(),
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex cursor-pointer items-center gap-1.5 rounded-lg border border-gray-200 bg-white/80 px-2.5 py-1.5 text-sm font-medium shadow-sm transition-colors hover:bg-white"
        style={{ color: textColor }}
      >
        <span>{currentConfig.flag}</span>
        <span>{currentConfig.label}</span>
        <svg
          className={`h-3.5 w-3.5 transition-transform ${isOpen ? "rotate-180" : ""}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 top-full z-20 mt-1 min-w-32 rounded-lg bg-white py-1 shadow-lg">
            {currencies.map((currency) => {
              const config = CURRENCY_CONFIG[currency] ?? {
                flag: "",
                label: currency.toUpperCase(),
              };
              return (
                <button
                  key={currency}
                  onClick={() => {
                    onCurrencyChange(currency);
                    setIsOpen(false);
                  }}
                  className={`flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-left text-sm transition-colors hover:bg-gray-100 ${
                    selectedCurrency === currency
                      ? "bg-gray-50 font-medium"
                      : ""
                  }`}
                >
                  <span>{config.flag}</span>
                  <span>{config.label}</span>
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
